<template>
	<div class="inner-page new-case">
		<AppHead title="New Case" />

		<PageHeader 
			title="New Case"
			desc="Open a new case and give it a description"
			:hasButton="false"
			:showHelper="true"
			helpTitle="Creation of a New Case"
			helpDesc="Please add a description which will help you to know a brief overview of this case."
			/>

		<CaseProgressBar :step="0" />

		<div class="new-case-form">
			
			<InputGroup
				title="1. Give a description"
				desc="Please describe this case in less than 100 characters"
				>

				<InputTextarea
					label="Description"
					v-model="formData.description"
					maxLength="100"
					/>

			</InputGroup>
			
			<InputGroup
				title="2. Assign patient reference"
				desc="This should be anonymised and traceable to the patient at your hospital"
				>

				<InputText
					label="Patient reference"
					type="text"
					placeholder="Please supply a patient reference if you have one"
					v-model="formData.patient_reference"
					/>

			</InputGroup>

			<InputGroup
				v-if="['admin', 'team_admin', 'team_user'].includes($page.props.user.user_type)"
				title="3. Assign a surgeon"
				desc="You must assign a surgeon user to this case, they will be the primary owner of the case. Only they, Distributor admins, Meshworks admins, and any defined editors will be able to edit the case."
				>

				<MultiSelect
					v-model="formData.user"
					:options="users"
					:singleSelectionOnly="true"
					/>

			</InputGroup>

			<InputGroup
				v-if="['admin', 'team_admin', 'team_user'].includes($page.props.user.user_type)"
				title="4. Assign viewers"
				desc="You can assign 'viewer' user types here. They will only be able to view the case regardless of if they are in the same distributor or not, they will also receive notifications about this case if they have set their notification preferences."
				>

				<MultiSelect
					v-model="formData.viewers"
					:options="viewers"
					/>

			</InputGroup>

			<InputGroup
				v-if="['admin', 'team_admin', 'team_user'].includes($page.props.user.user_type)"
				title="5. Assign Supporting Surgeons"
				desc="You can assign 'editor' user types here. They will be able to view and edit this case, they will also receive notifications about this case if they have set their notification preferences."
				>

				<MultiSelect
					v-model="formData.editors"
					:options="editors"
					/>

			</InputGroup>

			<InputGroup
				v-if="$page.props.user.user_type == 'admin'"
				title="6. Distributor"
				desc="Please assign the case to a distributor, or to skip adding the case to a distributor just leave 'Unassigned' selected."
				>
				<InputFancyRadio 
					label="Select a distributor to assign the user to"
					:options="selectableTeams"
					id="assignedTeam"
					v-model="formData.team"
					/>
			</InputGroup>


			<InputGroup
				title=""
				desc=""
				:skipWhiteBox="true"
				:noLine="true"
				>
				<Button
					label="Next"
					color="green"
					size="large"
					icon="save" 
					@click="submit"
					:disabled="!isFormComplete"
					/>
			</InputGroup>

		</div>

	</div>
</template>

<script>

import AppLayout from "@/Layouts/AppLayout.vue"
import AppHead from "@/Components/AppHead"
import PageHeader from "@/Components/PageHeader"
import Button from "@/Components/Button"
import ButtonDownload from "@/Components/ButtonDownload"
import InputGroup from "@/Components/InputGroup"
import CaseProgressBar from "@/Components/Cases/CaseProgressBar"
import InputText from "@/Components/InputText"
import InputTextarea from "@/Components/InputTextarea"
import InputFancyRadio from "@/Components/InputFancyRadio"
import MultiSelect from "@/Components/MultiSelect"

export default {
	components: {
		AppLayout,
		AppHead,
		PageHeader,
		Button,
		ButtonDownload,
		InputGroup,
		CaseProgressBar,
		InputText,
		InputTextarea,
		InputFancyRadio,
		MultiSelect
	},
	props: [
		'users',
		'viewers',
		'teams',
		'editors'
	],
	layout: AppLayout,
	data: () => {
		return {
			formData: {
				description: '',
				patient_reference: '',
				user: '',
				team: false,
				viewers: [],
				editors: []
			}
		}
	},
	methods: {
		submit(){
			if(this.isFormComplete){
				this.$inertia.post('/cases/new-case', this.formData)
			}
		}
	},
	computed: {
		isFormComplete(){
			if(['admin', 'team_admin'].includes(this.$page.props.user.user_type)){

				if(this.formData.description.length != 0 && this.formData.user != ''){
					return true
				}else{
					return false
				}

			}else{

				if(this.formData.description.length == 0){
					return false
				}else{
					return true
				}

			}
		},
		selectableTeams(){
			let teams = []
			teams.push({
				value: false,
				text: '- Unassigned -'
			})
			for(let team of this.teams){
				teams.push({
					value: team.id,
					text: team.name
				})
			}

			return teams
		}
	},
	mounted(){
		// console.log('users', this.users)
	}
};

</script>

<style scoped lang="sass">

.new-case
	.new-case-form
		padding-top: 30px

		select
			width: 100%
			height: 50px

		select[multiple]
			height: 200px

</style>